import Vue from 'vue'
import VueRouter from 'vue-router'

import Signin from '../views/Signin.vue'
import Signup from '../views/Signup.vue'
import EsqueceuSenha from '../views/EsqueceuSenha.vue'
import Usuarios from '../views/Usuarios.vue'
import Empresas from '../views/Empresas.vue'
import Fornecedores from '../views/Fornecedores.vue'
Vue.use(VueRouter)

const routes = [
	{
		path: '*',
		component: Empresas
	},
	{
		path: '/signin',
		name: 'Signin',
		component: Signin
	},
	{
		path: '/esqueceusenha',
		name: 'Esqueceu Senha',
		component: EsqueceuSenha
	},
	{
		path: '/signup',
		name: 'Signup',
		component: Signup
	},
	{
		path: '/usuarios',
		name: 'Usuarios',
		component: Usuarios
	},
	{
		path: '/empresas',
		name: 'Empresas',
		component: Empresas
	},
	{
		path: '/fornecedores',
		name: 'Fornecedores',
		component: Fornecedores
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
export default router
